var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvgPace = function SvgAvgPace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "avg_pace_svg__a",
    width: 20,
    height: 21,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#avg_pace_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    fillOpacity: 0.7,
    d: "M12.709 4.667q-.437 0-.74-.302a1 1 0 0 1-.302-.74q0-.437.302-.74.303-.3.74-.301.437 0 .74.302.3.302.301.74 0 .437-.302.739a1 1 0 0 1-.74.302m0 13.75q-.437 0-.74-.302a1 1 0 0 1-.302-.74q0-.437.302-.74.303-.3.74-.301.437 0 .74.302.3.302.301.74 0 .436-.302.739a1 1 0 0 1-.74.302m3.333-10.833q-.437 0-.74-.302a1 1 0 0 1-.302-.74q0-.437.302-.74.303-.302.74-.302.438 0 .74.302.302.303.302.74 0 .438-.302.74a1 1 0 0 1-.74.302m0 7.916q-.437 0-.74-.302a1 1 0 0 1-.302-.74q0-.436.302-.739.303-.302.74-.302.438 0 .74.302.302.303.302.74t-.302.74a1 1 0 0 1-.74.301m1.25-3.958q-.438 0-.74-.302a1 1 0 0 1-.302-.74q0-.437.302-.74.303-.3.74-.301.438 0 .74.302t.302.74-.302.739a1 1 0 0 1-.74.302M10 18.834a8.1 8.1 0 0 1-3.25-.657 8.4 8.4 0 0 1-2.646-1.78 8.4 8.4 0 0 1-1.78-2.647 8.1 8.1 0 0 1-.657-3.25q0-1.729.656-3.25a8.4 8.4 0 0 1 1.781-2.646 8.4 8.4 0 0 1 2.646-1.78A8.1 8.1 0 0 1 10 2.166v1.667q-2.79 0-4.729 1.937-1.937 1.938-1.937 4.73 0 2.79 1.937 4.729 1.938 1.937 4.73 1.937zm0-6.667q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177q0-.104.011-.218a.8.8 0 0 1 .052-.22L6.667 8.335l1.167-1.167 1.729 1.73q.083-.023.437-.063.688 0 1.177.49.49.489.49 1.176 0 .688-.49 1.177-.489.49-1.177.49"
  }))));
};
export default SvgAvgPace;